export default "__VITE_ASSET__DLfp$Lp7__"